import type { ReactElement } from 'react';
import {
  CUSTOMERS_HOST_MODULES,
  PROCUREMENT_MASTER_PAGES,
  moduleSharedPath,
  type SharedMasterPage,
} from '@/config/moduleSharedPaths';
import {
  CustomersPage,
  InventoryLedgerPage,
  InventoryPage,
  ProductsPage,
  SuppliersPage,
} from './lazyPages';

function pageElement(page: SharedMasterPage): ReactElement {
  switch (page) {
    case 'customers':
      return <CustomersPage />;
    case 'suppliers':
      return <SuppliersPage />;
    case 'products':
      return <ProductsPage />;
    case 'inventory':
      return <InventoryPage />;
    case 'inventory/ledger':
      return <InventoryLedgerPage />;
    default:
      return <CustomersPage />;
  }
}

/** Route definitions for shared master-data pages under module prefixes. */
export const MODULE_SHARED_MASTER_ROUTES: { path: string; element: ReactElement }[] = [
  ...CUSTOMERS_HOST_MODULES.filter((mod) => mod !== 'POS').map((mod) => ({
    path: moduleSharedPath(mod, 'customers'),
    element: <CustomersPage />,
  })),
  ...PROCUREMENT_MASTER_PAGES.map((page) => ({
    path: moduleSharedPath('PROCUREMENT', page),
    element: pageElement(page),
  })),
];
